import { lazy } from 'react';

export const MedDeviceManufacturersPage = lazy(
  () => import('./MedDeviceManufacturersPage'),
);
